var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerpetrator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 79.043)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6670",
    "data-name": "Rect\\xE1ngulo 6670",
    width: 58,
    height: 58,
    transform: "translate(0 -79.043)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-hacker-1381807",
    transform: "translate(6.422 -72.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9613",
    "data-name": "Trazado 9613",
    d: "M44.3,40.751l-5.272-2.217a7.537,7.537,0,0,0-2.611-8.648l-1.023-.76a17.32,17.32,0,0,0,.526-2.4,7.693,7.693,0,0,0,2.738-5.846,3.756,3.756,0,0,0-1.116-2.689,3.805,3.805,0,0,0-1.043-.736V12.772c0-4.409-2.241-6.017-4.536-7.284A40.8,40.8,0,0,0,26.09,3.062V2.438a1.218,1.218,0,1,0-2.436,0v.624c-.974.326-2.733,1-5.8,2.4-2.28,1.047-4.614,2.738-4.614,7.308v4.682a3.81,3.81,0,0,0-.974.687,3.751,3.751,0,0,0-1.16,2.728,7.673,7.673,0,0,0,2.845,5.949,17.159,17.159,0,0,0,.487,2.27l-1.111.818a7.537,7.537,0,0,0-2.611,8.648L5.452,40.766A7.24,7.24,0,0,0,1,47.548a1.218,1.218,0,0,0,1.218,1.2h0a1.218,1.218,0,0,0,1.218-1.228,4.814,4.814,0,0,1,2.957-4.511l5.51-2.319a7.586,7.586,0,0,0,.974,1.043l5.535,4.775A1.218,1.218,0,1,0,20,44.673l-5.51-4.779a5.15,5.15,0,0,1,.292-8.034l.555-.409a13.218,13.218,0,0,0,1.189,2.012v3.922a1.218,1.218,0,0,0,.443.94L24.1,44.172a1.218,1.218,0,0,0,1.544,0l7.128-5.846a1.218,1.218,0,0,0,.443-.94v-3.8a13.033,13.033,0,0,0,1.262-2.1l.487.361a5.15,5.15,0,0,1,.292,8.034l-5.51,4.779a1.219,1.219,0,0,0,1.593,1.846l5.535-4.775a7.571,7.571,0,0,0,.974-1.043l5.505,2.324a4.814,4.814,0,0,1,2.957,4.5,1.218,1.218,0,0,0,1.2,1.233h0a1.218,1.218,0,0,0,1.233-1.208A7.24,7.24,0,0,0,44.3,40.751ZM18.87,7.666A52.87,52.87,0,0,1,24.843,5.23a41.46,41.46,0,0,1,5.954,2.4c1.92,1.057,3.274,2.046,3.274,5.15v2.991l-.429-.263a17.1,17.1,0,0,0-17.539,0l-.429.253V12.772C15.674,9.727,16.848,8.591,18.87,7.666ZM33.427,18.214l-.624,1.2a1.155,1.155,0,0,1-1.554.487,14.558,14.558,0,0,0-6.377-1.739,14.558,14.558,0,0,0-6.4,1.715,1.15,1.15,0,0,1-.887.073,1.1,1.1,0,0,1-.643-.555l-.6-1.2,1.043-.619a14.66,14.66,0,0,1,15.045,0ZM31.206,32.177a2.2,2.2,0,0,0-.448,1.32V36.81l-5.885,4.843-5.91-4.843V33.4a2.178,2.178,0,0,0-.424-1.32,13.154,13.154,0,0,1-2.256-6.071,1.218,1.218,0,0,0-.512-.857,5.242,5.242,0,0,1-2.246-4.287,1.335,1.335,0,0,1,.409-.974,1.379,1.379,0,0,1,.37-.248l.438.867a3.518,3.518,0,0,0,2.066,1.769,3.566,3.566,0,0,0,2.748-.214A12.136,12.136,0,0,1,24.872,20.6a12.141,12.141,0,0,1,5.3,1.462A3.6,3.6,0,0,0,35,20.528l.434-.9a1.384,1.384,0,0,1,.4.273,1.32,1.32,0,0,1,.395.974A5.252,5.252,0,0,1,34.061,25.1a1.218,1.218,0,0,0-.487.848A13.067,13.067,0,0,1,31.206,32.177Z",
    transform: "translate(-0.999 -1.22)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9614",
    "data-name": "Trazado 9614",
    d: "M84.538,64.184h2.095a2.816,2.816,0,0,0,2.811-2.811V59.278a1.218,1.218,0,0,0-2.436,0v2.095a.375.375,0,0,1-.375.375H84.538a1.218,1.218,0,0,0,0,2.436Z",
    transform: "translate(-43.213 -30.368)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9615",
    "data-name": "Trazado 9615",
    d: "M84.538,12.436h2.095a.375.375,0,0,1,.375.375v2.095a1.218,1.218,0,0,0,2.436,0V12.811A2.816,2.816,0,0,0,86.633,10H84.538a1.218,1.218,0,0,0,0,2.436Z",
    transform: "translate(-43.213 -5.722)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9616",
    "data-name": "Trazado 9616",
    d: "M5.328,16.134a1.218,1.218,0,0,0,1.218-1.218V12.821a.375.375,0,0,1,.375-.385H9.016a1.218,1.218,0,0,0,0-2.436H6.921A2.816,2.816,0,0,0,4.11,12.811v2.095a1.218,1.218,0,0,0,1.218,1.228Z",
    transform: "translate(-2.594 -5.722)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9617",
    "data-name": "Trazado 9617",
    d: "M6.921,64.184H9.016a1.218,1.218,0,1,0,0-2.436H6.921a.375.375,0,0,1-.375-.375V59.278a1.218,1.218,0,0,0-2.436,0v2.095a2.816,2.816,0,0,0,2.811,2.811Z",
    transform: "translate(-2.594 -30.368)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9618",
    "data-name": "Trazado 9618",
    d: "M48.627,58.06H45.178a1.218,1.218,0,1,0,0,2.436h3.454a1.218,1.218,0,1,0,0-2.436Z",
    transform: "translate(-23.029 -30.368)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9619",
    "data-name": "Trazado 9619",
    d: "M44.571,18.557a1.213,1.213,0,0,0,.862-.356,1.642,1.642,0,0,1,2.319,0,1.22,1.22,0,1,0,1.725-1.725,4.083,4.083,0,0,0-5.764,0,1.218,1.218,0,0,0,.857,2.08Z",
    transform: "translate(-22.719 -8.433)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerpetrator);
export default __webpack_public_path__ + "static/media/icon-perpetrator.e894a878e4e7ca8cd7b5745779cb1edf.svg";
export { ForwardRef as ReactComponent };